import React from "react";

import { AlertCircle } from "lucide-react";

import Button from "../../Components/Button";
import CommonModal from "../../Components/Modal";

interface SendReminderModalProps {
  isOpen: boolean;
  toggle: () => void;
  invitedEmail: string;
  onConfirm: () => void;
  loading?: boolean;
  error?: string | null;
}

const SendReminderModal: React.FC<SendReminderModalProps> = ({
  isOpen,
  toggle,
  invitedEmail,
  onConfirm,
  loading = false,
  error = null,
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title="Send reminder"
      size="md"
    >
      <div>
        <p className="text-sm text-gray-600 leading-relaxed">
          Send a reminder invite to{" "}
          <strong className="text-gray-900 font-semibold">
            {invitedEmail}
          </strong>
          ?
        </p>

        {error ? (
          <div
            className="mt-4 flex gap-2.5 rounded-lg border border-red-200 bg-red-50 px-4 py-3"
            role="alert"
          >
            <AlertCircle
              className="mt-0.5 h-5 w-5 shrink-0 text-red-600"
              aria-hidden
            />
            <p className="m-0 text-sm leading-relaxed text-red-900">{error}</p>
          </div>
        ) : null}

        <div className="mt-6 flex justify-end gap-3 border-t border-gray-100 pt-5">
          <Button variant="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
          >
            Send reminder
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default SendReminderModal;
